<template>
  <div class="Product" ref="Product">
    <Head :isWhite="isWhiteLogo" :isMenu="isMenu" @isMenuShow="isMenuShow" />
    <Banner BannerName="Product_Banner" MenuName="科技教育产品研发" :MenuActive="7" />
    <div class="container">
      <p>科技教育产品研发</p>
      <span>
        集团成立教育产品研发中心，整合现有资源，拓展全方位教育服务产业链，打通前后端服务环节，让互联网与科技创新结合，开发全新科创教育产品。丰富教育资源库，充分发展信<br />息理论与技术，给予留学生更好的教育服务。
      </span>
      <p>研发体系：教育产品评估——产品初步设计——开发与上线——持续迭代优化</p>
      <div class="list">
        <p>研发成果</p>
        <ul>
          <li>
            <img src="http://cso-group.oss-cn-hongkong.aliyuncs.com/CISO/Business/Product/Product_img1.png" width="345px" />
            <div class="text">
              <p>自主研发线上moodle平台</p>
              <span>
                集团自主研发的线上moodle系统，采用新型数字化技术，搭建学术多层次模块化教育平台，提高各种应用的基础性能，同时基于网络数据分析将教育课程、直播视频、课件系统性排列拆分，打造一体化共通体，便于学员快速检索课程、随时进行线上课业并了解最新讯息。
              </span>
            </div>
          </li>
          <li>
            <img src="http://cso-group.oss-cn-hongkong.aliyuncs.com/CISO/Business/Product/Product_img2.png" width="345px" />
            <div class="text">
              <p>互联网+课程辅导平台</p>
              <span> 通过搭建辅导课程平台，串联起上下游，搭建快速共享教育资源的桥梁，便于多向沟通与后续服务。同时结合辅导系统，从根本上解决海外学员与教辅老师沟通难题。 </span>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <Foot @isBackTop="isBackTop" />
  </div>
</template>
<script>
import Head from '@/components/Head'
import Banner from '@/components/Banner'
import Foot from '@/components/Foot'
export default {
  components: {
    Head,
    Banner,
    Foot
  },
  data() {
    return {
      isWhiteLogo: false,
      isMenu: false
    }
  },
  mounted() {},
  methods: {
    isMenuShow(e) {
      this.isMenu = e
    },
    isBackTop() {
      let _this = this
      let ScrollTime = setInterval(() => {
        if (_this.$refs.Product.scrollTop > 0) {
          _this.$refs.Product.scrollTop = _this.$refs.Product.scrollTop - 50
        }
        if (_this.$refs.Product.scrollTop == 0) {
          clearInterval(ScrollTime)
        }
      }, this.$refs.Product.scrollTop / 1000000)
    }
  }
}
</script>
<style lang="less" scoped>
.Product {
  width: 100%;
  height: 100%;
  min-width: 1440px;
  overflow-x: hidden;
  overflow-y: auto;
  &::-webkit-scrollbar {
    display: none;
  }
  /deep/.Banner {
    .Menu {
      display: flex;
      align-items: center;
      justify-content: center;
      ul {
        width: 1400px;
        justify-content: space-between;
        li {
          margin-left: 0;
        }
      }
    }
  }
  .container {
    width: 1400px;
    overflow: hidden;
    margin: 72px auto 82px auto;
    > p {
      font-size: 32px;
      line-height: 1;
      text-align: center;
      font-family: 'Heavy';
      color: #111111;
      &:nth-child(3) {
        font-size: 24px;
        font-family: 'Bold';
        color: #2d64fa;
        margin-top: 52px;
        padding-left: 5px;
      }
    }
    > span {
      font-size: 14px;
      color: #111111;
      display: block;
      margin-top: 33px;
      text-align: center;
      line-height: 30px;
    }
    .list {
      width: 100%;
      overflow: hidden;
      margin-top: 45px;
      p {
        font-size: 24px;
        line-height: 1;
        color: #2d64fa;
        font-family: 'Bold';
      }
      ul {
        width: 100%;
        height: 300px;
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 28px;
        li {
          width: 690px;
          height: 300px;
          overflow: hidden;
          display: flex;
          align-items: center;
          justify-content: space-between;
          .text {
            width: 345px;
            height: 300px;
            overflow: hidden;
            padding: 50px 32px 0 33px;
            background: #f8f8f8;
            p {
              font-size: 16px;
              color: #111111;
              line-height: 1;
              font-family: 'Bold';
            }
            span {
              display: block;
              width: 100%;
              overflow: hidden;
              font-size: 14px;
              color: #111111;
              text-align: justify;
              margin-top: 30px;
              line-height: 24px;
            }
          }
        }
      }
    }
  }
}
</style>
